import { getCountryByIp, getDukpayRatio } from '@/api/index';
import { getCountryListAjax, getPayChannelsAjax } from '@/api/pay';
import { isSafari } from '@/tools/common';
import { Dialog } from 'vant';
import { startTime } from '@/api/pay';

/**
 * 充值拦截反馈模块
 * 基于Vuex的状态管理，处理充值相关的拦截逻辑和反馈功能
 */

const state = () => ({
  // 弹窗是否激活（true=激活状态，底部紫条可见；false=未激活，完全隐藏）
  // openExpanded 被调用后设为 true，进入折叠状态（紫条显示）
  // dismissSecondPaymentDialog 设为 false，回到隐藏状态
  dialogDismissed: false,

  // 当前系统语言
  currentCountry: '',

  // 本地支付通道列表（缓存）
  paymentMethodsLocal: [],

  // 当前选择的国家信息
  selCountryInfo: null,

  // 支付列表是否展开（true=打开状态，false=折叠/关闭状态）
  isExpanded: false,

  // 订单数据
  orderData: null,

  // 已失败的支付方式列表（用于过滤推荐支付方式）
  failedList: [],

  // 用户邮箱（来自下单接口）
  userEmail: '',

  // 当前选中的支付方式索引（null 表示全部折叠）
  activePayIndex: null
})

const mutations = {
  // 设置弹窗是否被用户关闭过
  SET_DIALOG_DISMISSED(state, value) {
    state.dialogDismissed = value;
  },

  // 设置当前系统语言
  SET_CURRENT_COUNTRY(state, country) {
    state.currentCountry = country;
  },

  // 设置本地支付通道列表
  SET_PAYMENT_METHODS_LOCAL(state, methods) {
    state.paymentMethodsLocal = methods;
  },

  // 设置选中国家信息
  SET_SEL_COUNTRY_INFO(state, info) {
    state.selCountryInfo = info;
  },

  // 设置支付列表展开状态
  SET_IS_EXPANDED(state, expanded) {
    state.isExpanded = expanded;
  },

  // 设置订单数据
  SET_ORDER_DATA(state, data) {
    state.orderData = data;
  },

  // 设置已失败的支付方式列表
  SET_FAILED_LIST(state, list) {
    console.log('[rechargeIntercept] SET_FAILED_LIST list:', list);
    state.failedList = list || [];
  },

  // 设置用户邮箱
  SET_USER_EMAIL(state, email) {
    state.userEmail = email || '';
  },

  // 设置当前选中的支付方式索引
  SET_ACTIVE_PAY_INDEX(state, index) {
    state.activePayIndex = index;
  }

}

const actions = {
  // 主动展示二次支付弹窗（从关闭状态恢复显示，展开内容）
  showSecondPaymentPopup({ commit }) {
    commit('SET_DIALOG_DISMISSED', true);
  },

  // 关闭二次支付弹窗（进入关闭状态，折叠内容，紫条也隐藏）
  dismissSecondPaymentDialog({ commit }) {
    commit('SET_DIALOG_DISMISSED', false);
    commit('SET_IS_EXPANDED', false);
  },

  // 关闭二次支付弹窗并重置相关状态
  closeSecondPaymentDialogWithReset({ commit, dispatch }) {
    commit('SET_DIALOG_DISMISSED', true);
    commit('SET_IS_EXPANDED', false);
    localStorage.removeItem('no');
  },

  // 支付通道相关
  async fetchPayChannelsDirect({ commit, state }) {
    try {
      // 优先使用首页选中的国家，确保与首页支付列表数据一致
      let targetCountry = null;

      // 获取国家列表（使用当前系统语言）
      const countryListRes = await getCountryListAjax(state.currentCountry || 'en');
      console.log('[rechargeIntercept] fetchPayChannelsDirect - getCountryListAjax response:', countryListRes);
      // 兼容不同返回结构：res.data.result 可能是数组，也可能包含 countryList 字段
      let countryList = [];
      if (countryListRes) {
        if (countryListRes.data && countryListRes.data.result) {
          if (Array.isArray(countryListRes.data.result)) {
            countryList = countryListRes.data.result;
          } else if (countryListRes.data.result.countryList) {
            countryList = countryListRes.data.result.countryList;
          }
        } else if (countryListRes.result) {
          if (Array.isArray(countryListRes.result)) {
            countryList = countryListRes.result;
          } else if (countryListRes.result.countryList) {
            countryList = countryListRes.result.countryList;
          }
        }
      }
      console.log('[rechargeIntercept] fetchPayChannelsDirect - parsed countryList length:', countryList.length);

      // 优先使用首页选中的国家
      if (state.selCountryInfo && state.selCountryInfo.coding) {
        console.log('[rechargeIntercept] fetchPayChannelsDirect - using selected country from homepage:', state.selCountryInfo);
        targetCountry = state.selCountryInfo;
      } else {
        // 如果没有选中国家，则使用IP获取的国家作为fallback
        console.log('[rechargeIntercept] fetchPayChannelsDirect - no selected country, using IP detection');
        const ipRes = await getCountryByIp();
        console.log('[rechargeIntercept] fetchPayChannelsDirect - getCountryByIp response:', ipRes);
        const userCountryCoding = (ipRes && ipRes.data && ipRes.data.result) ||
                                 (ipRes && ipRes.result) ||
                                 (ipRes && ipRes.data) ||
                                 ipRes;

        // 查找目标国家
        targetCountry = countryList.find((c) => c.coding === userCountryCoding) ||
                       countryList.find((c) => c.coding === 'US') ||
                       countryList[0];
        console.log('[rechargeIntercept] fetchPayChannelsDirect - targetCountry from IP:', targetCountry);
      }

      if (!targetCountry) return null;

      // 获取用户token
      const userInfo = localStorage.getItem('userInfo');
      let token = '';
      if (userInfo) {
        try {
          const userInfoObj = JSON.parse(userInfo);
          token = userInfoObj.token || '';
        } catch (e) {
          console.warn('[rechargeIntercept] parse userInfo failed:', e);
        }
      }

      // 设置需要隐藏的支付方式
      let hidePayName = []
      if(!isSafari()){
        hidePayName.push('ApplePay')
        const ua = navigator.userAgent;
        const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(ua);
        if (isMobile) {
          // 只有移动端非iOS才隐藏，pc不进行隐藏
          hidePayName.push('OnlyPay-ApplePay');
          hidePayName.push('Antom-ApplePay'); // 隐藏Antom在安卓下面的ApplePay
          hidePayName.push('APPLE_PAY（HaiPay）'); // 隐藏HaiPay的ApplePay-灰线正式
          hidePayName.push('Usolvepay-applePay');
        }
      }

      // 获取支付通道（API 接收 params 对象）
      const payRes = await getPayChannelsAjax({
        countryId: targetCountry.countryId,
        language: 'en',
        systoken: token,
        hidePayName: hidePayName.toString()
      });
      console.log('[rechargeIntercept] fetchPayChannelsDirect - getPayChannelsAjax response:', payRes);
      const channels = (payRes && payRes.data && payRes.data.result) ||
                      (payRes && payRes.result) ||
                      [];
      console.log('[rechargeIntercept] fetchPayChannelsDirect - parsed channels length:', channels , channels.length);

      // 当国家代码为RU时，获取dukpay汇率并挂载到每个支付通道上
      if (targetCountry.coding === 'RU') {
        try {
          const { data } = await getDukpayRatio(targetCountry.countryId);
          const dukpayRate = data && data.data && data.data.rate;
          if (dukpayRate) {
            channels.forEach(item => {
              item.dukpayRate = dukpayRate;
            });
            console.log('[rechargeIntercept] fetchPayChannelsDirect - dukpayRate set:', dukpayRate);
          }
        } catch (e) {
          console.warn('[rechargeIntercept] getDukpayRatio failed:', e);
        }
      }

      // 根据 orderData 过滤支付方式
      let filteredChannels = channels;
      // hidePayName中的支付方式，不显示在支付方式列表中,做双重处理，防止接口未生效
      try {
        filteredChannels = filteredChannels.filter((payInfo) => {
          return !hidePayName.includes(payInfo.rechargePayType.payTypeName);
        })
      } catch (error) {
        console.warn('[rechargeIntercept] filter hidePayName failed:', error);
      }

      if (state.orderData) {
        console.log('[rechargeIntercept] fetchPayChannelsDirect - filtering channels based on orderData:', state.orderData);

        filteredChannels = channels.filter(channel => {
          // 检查 rechargePayType 是否存在
          if (!channel.rechargePayType) {
            return false;
          }

          const refundType = channel.rechargePayType.refundType;

          // 当 showNoRefund 为 true 时，展示无退款可能性的支付方式 (refundType === 3)
          if (state.orderData.showNoRefund && refundType === 3) {
            return true;
          }

          // 当 showSmaller 为 true 时，展示较小退款可能性的支付方式 (refundType === 2)
          if (state.orderData.showSmaller && refundType === 2) {
            return true;
          }

          // 默认情况下过滤掉所有支付方式
          return false;
        });

        console.log('[rechargeIntercept] fetchPayChannelsDirect - failedList:', state.failedList);

        // 过滤掉已失败的支付方式（failedList）
        if (state.failedList && state.failedList.length > 0) {
          const failedList = state.failedList;
          console.log('[rechargeIntercept] fetchPayChannelsDirect - filtering failedList:', failedList);
          filteredChannels = filteredChannels.filter(channel => {
            const rechargeId = channel.rechargeId;
            // 如果 rechargeId 不在 failedList 中，则保留
            return !failedList.includes(rechargeId);
          });
          console.log('[rechargeIntercept] fetchPayChannelsDirect - after failedList filter, length:', filteredChannels.length);
        }

        // 当 showTrader 为 true 时，在列表开头添加币商选项
        if (state.orderData.showTrader) {
          console.log('[rechargeIntercept] fetchPayChannelsDirect - adding trader option');
          const traderOption = {
            id: 'trader',
            name: window.rootApp.$t('m.reseller'),
            rechargePayType: {
              refundType: 0, // 币商的退款类型，可以根据需要调整
              type: 'trader'
            },
            // 添加其他必要的字段
            isTrader: true
          };
          filteredChannels = [traderOption, ...filteredChannels];
          console.log('[rechargeIntercept] fetchPayChannelsDirect - added trader, total length:', filteredChannels.length);
        }
      }


      // 无论是否有 orderData，都需要过滤掉已失败的支付方式（failedList）
      if (state.failedList && state.failedList.length > 0) {
        const failedList = state.failedList;
        console.log('[rechargeIntercept] fetchPayChannelsDirect - filtering failedList:', failedList);
        filteredChannels = filteredChannels.filter(channel => {
          const rechargeId = channel.rechargeId;
          // 如果 rechargeId 不在 failedList 中，则保留
          return !failedList.includes(rechargeId);
        });
        console.log('[rechargeIntercept] fetchPayChannelsDirect - after failedList filter, length:', filteredChannels.length);
      }

      console.log('SET_PAYMENT_METHODS_LOCALSET_PAYMENT_METHODS_LOCAL', filteredChannels)

      // 更新状态
      commit('SET_PAYMENT_METHODS_LOCAL', filteredChannels);
      commit('SET_SEL_COUNTRY_INFO', targetCountry);

    } catch (err) {
      console.warn('[rechargeIntercept] fetchPayChannelsDirect failed', err);
      console.error(err);
      return null;
    }
  },

  // 支付列表展开相关
  async openExpanded({ commit, dispatch, state }, orderData = null) {
    if (orderData) {
      commit('SET_ORDER_DATA', orderData);
      console.log('[rechargeIntercept] orderData failedList:', orderData.failedList);
      // 保存已失败的支付方式列表
      // 使用 != null 判断，确保 null 和 undefined 都能被正确处理
      if (orderData.failedList != null && Array.isArray(orderData.failedList) && orderData.failedList.length > 0) {
        commit('SET_FAILED_LIST', orderData.failedList);
        console.log('[rechargeIntercept] failedList saved:', orderData.failedList);
      } else {
        // 当接口返回的 failedList 为空、null 或 undefined 时，清空 state 中的缓存值
        commit('SET_FAILED_LIST', []);
        console.log('[rechargeIntercept] failedList is empty/null, cleared state');
      }
      // 保存用户邮箱
      if (orderData.email) {
        commit('SET_USER_EMAIL', orderData.email);
        console.log('[rechargeIntercept] userEmail saved:', orderData.email);
      }
    }

    // 如果已有缓存的支付通道数据，且没有新的 orderData，直接使用缓存展开，避免重复请求
    if (!orderData && state.paymentMethodsLocal && state.paymentMethodsLocal.length > 0) {
      commit('SET_ACTIVE_PAY_INDEX', null);
      commit('SET_IS_EXPANDED', true);
      commit('SET_DIALOG_DISMISSED', true);
      return true;
    }

    // 每次都请求支付通道列表
    await dispatch('fetchPayChannelsDirect');

    // 检查支付通道列表是否有值
    if (state.paymentMethodsLocal && state.paymentMethodsLocal.length > 0) {
      // 打开二次支付弹窗时清除启动轮询的标识 startTime，避免残留影响后续流程
      try {
        localStorage.removeItem(startTime);
      } catch (e) {
        console.warn('[rechargeIntercept] remove startTime failed', e);
      }
      commit('SET_ACTIVE_PAY_INDEX', null);
      commit('SET_IS_EXPANDED', true);
      commit('SET_DIALOG_DISMISSED', true);
      return true; // 成功打开弹窗
    } else {
      console.log('[rechargeIntercept] 支付通道列表为空，不打开二次支付弹窗，转而显示默认提示弹窗');
      // 支付通道为空时，显示默认连接失败提示弹窗
      Dialog.confirm({
        message: window.rootApp.$t('m.recharge_fail_risk_network'),
        confirmButtonText: window.rootApp.$t('m.feedback'),
        cancelButtonText: window.rootApp.$t('m.falseText')
      }).then(() => {
        // 跳转到反馈页面
        window.rootApp.$router.push({
          path: '/feedback',
          query: {
            from: 'pay',
            orderNo: state.orderData && state.orderData.no || ''
          }
        });
      }).catch(() => {
        // 取消按钮点击，关闭弹窗
      });
      return false; // 支付通道为空，不打开弹窗
    }
  },

  closeExpanded({ commit, state }, dismiss = false) {
    commit('SET_IS_EXPANDED', false);
    if (dismiss) {
      commit('SET_DIALOG_DISMISSED', false);
    }
  },


}

const getters = {
  // 弹窗是否被用户关闭过（关闭状态时为 true，紫条也不显示）
  dialogDismissed: state => state.dialogDismissed,

  // 当前系统语言
  currentCountry: state => state.currentCountry,

  paymentMethodsLocal: state => state.paymentMethodsLocal,
  selCountryInfo: state => state.selCountryInfo,
  isExpanded: state => state.isExpanded,

  // 订单数据
  orderData: state => state.orderData,

  // 已失败的支付方式列表
  failedList: state => state.failedList,

  // 用户邮箱
  userEmail: state => state.userEmail,

  // 当前选中的支付方式索引
  activePayIndex: state => state.activePayIndex
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/rechargeIntercept.js